import type { CampaignWait } from '#/entities/campaign'

interface CampaignWaitConnectorProps {
  wait: CampaignWait
}

/**
 * The rail between two steps. The line is drawn in three pieces rather than one
 * behind the pill so the pill sits *in* the rail instead of on top of it — the
 * card background would otherwise have to mask it.
 */
export function CampaignWaitConnector({ wait }: CampaignWaitConnectorProps) {
  return (
    <div className="flex flex-col items-start pl-6" aria-hidden="true">
      <span className="h-3 w-0.5 bg-campaign-blocked" />
      <div className="flex items-center gap-3">
        <span className="h-5 w-0.5 bg-campaign-blocked" />
        <p className="flex flex-wrap items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs">
          <span className="font-medium text-gray-900">{wait.label}</span>
          <span className="text-gray-500">{wait.condition}</span>
        </p>
      </div>
      <span className="h-3 w-0.5 bg-campaign-blocked" />
    </div>
  )
}
